export const heroData = {
  tagline: '海量漫画 · 免费畅读',
  title: 'YY漫画 · 韩漫日漫国漫一站式阅读平台',
  slogan: '下拉即读，追更不等待',
  description:
    'YY漫画网汇聚全网优质韩漫、日漫、国漫资源，涵盖恋爱、热血、奇幻、悬疑、搞笑等全品类漫画。无论你是韩漫爱好者、日漫铁粉还是国漫追随者，这里都能找到你想看的每一部作品。支持下拉式流畅阅读，收藏追更功能让你不错过任何一话更新。每日更新推荐，热门榜单实时追踪，为漫画爱好者打造最舒适的在线阅读体验。',
  stats: [
    { label: '收录漫画', value: '50,000+' },
    { label: '每日更新', value: '200+部' },
    { label: '在读用户', value: '300万+' },
  ],
  primaryCta: '立即阅读',
  secondaryCta: '探索热门',
};

export const commentsData = [
  {
    id: 1,
    name: '漫画控小雨',
    avatar: 'ri-user-3-line',
    time: '2小时前',
    content:
      '《女神降临》太好看了！画风绝美，剧情也超有代入感，每天睡前必追一话才能安心睡觉。YY漫画的更新速度真的快，韩漫资源也比我之前用的其他站全多了。',
    comic: '女神降临',
    likes: 1286,
  },
  {
    id: 2,
    name: '追更达人阿明',
    avatar: 'ri-user-3-line',
    time: '5小时前',
    content:
      '从大学开始就是日漫铁粉了，看过几百部漫画，YY漫画是我用过体验最好的漫画站。下拉式阅读真的很流畅，不用一页页翻，追更收藏功能也特别方便。',
    comic: '咒术回战',
    likes: 953,
  },
  {
    id: 3,
    name: '国漫爱好者小K',
    avatar: 'ri-user-3-line',
    time: '1天前',
    content:
      '最近国漫质量真的越来越高了，《斗破苍穹》的动画化改编也很成功。YY漫画上国漫资源很丰富，分类也很清晰，找漫画特别方便。强烈推荐给喜欢看漫画的朋友们！',
    comic: '斗破苍穹',
    likes: 2104,
  },
];

export const rankingData = [
  {
    id: 1,
    rank: 1,
    title: '女神降临',
    author: '喵喵',
    genre: '韩漫 · 恋爱',
    rating: 9.8,
    views: '128.5万',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%20illustration%20with%20beautiful%20female%20character%20soft%20pastel%20colors%20dreamy%20atmosphere%20clean%20simple%20background%20artistic%20style%20warm%20lighting&width=400&height=560&seq=rank-01&orientation=portrait',
  },
  {
    id: 2,
    rank: 2,
    title: '咒术回战',
    author: '芥见下下',
    genre: '日漫 · 热血',
    rating: 9.7,
    views: '115.2万',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20action%20comic%20cover%20illustration%20with%20dynamic%20character%20posing%20dark%20mystical%20theme%20bold%20lines%20clean%20simple%20background%20dramatic%20lighting%20artistic%20style&width=400&height=560&seq=rank-02&orientation=portrait',
  },
  {
    id: 3,
    rank: 3,
    title: '斗破苍穹',
    author: '天蚕土豆',
    genre: '国漫 · 玄幻',
    rating: 9.6,
    views: '98.7万',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20comic%20cover%20illustration%20with%20martial%20arts%20character%20flame%20theme%20epic%20atmosphere%20clean%20simple%20background%20warm%20orange%20tones%20artistic%20style&width=400&height=560&seq=rank-03&orientation=portrait',
  },
  {
    id: 4,
    rank: 4,
    title: '某天成为公主',
    author: 'Spoon',
    genre: '韩漫 · 奇幻',
    rating: 9.5,
    views: '87.3万',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20comic%20cover%20illustration%20princess%20theme%20elegant%20character%20roses%20soft%20pink%20tones%20clean%20simple%20background%20dreamy%20atmosphere%20artistic%20style&width=400&height=560&seq=rank-04&orientation=portrait',
  },
  {
    id: 5,
    rank: 5,
    title: '间谍过家家',
    author: '远藤达哉',
    genre: '日漫 · 搞笑',
    rating: 9.4,
    views: '76.1万',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20comedy%20spy%20family%20comic%20cover%20illustration%20with%20quirky%20characters%20warm%20family%20theme%20clean%20simple%20background%20bright%20cheerful%20colors%20artistic%20style&width=400&height=560&seq=rank-05&orientation=portrait',
  },
  {
    id: 6,
    rank: 6,
    title: '完美世界',
    author: '辰东',
    genre: '国漫 · 玄幻',
    rating: 9.3,
    views: '65.8万',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20epic%20fantasy%20comic%20cover%20illustration%20with%20powerful%20warrior%20character%20celestial%20theme%20golden%20tones%20clean%20simple%20background%20majestic%20atmosphere%20artistic%20style&width=400&height=560&seq=rank-06&orientation=portrait',
  },
  {
    id: 7,
    rank: 7,
    title: '我独自升级',
    author: 'Chugong',
    genre: '韩漫 · 动作',
    rating: 9.2,
    views: '54.3万',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20dungeon%20comic%20cover%20illustration%20with%20cool%20hunter%20character%20dark%20shadow%20theme%20clean%20simple%20background%20intense%20atmosphere%20artistic%20style&width=400&height=560&seq=rank-07&orientation=portrait',
  },
];

export const indexData = [
  { id: 1, name: '韩漫精选', icon: 'ri-earth-line', count: 2840, color: 'accent' },
  { id: 2, name: '日漫精选', icon: 'ri-earth-line', count: 3560, color: 'primary' },
  { id: 3, name: '国漫精选', icon: 'ri-earth-line', count: 1920, color: 'secondary' },
  { id: 4, name: '恋爱甜宠', icon: 'ri-heart-line', count: 1260, color: 'accent' },
  { id: 5, name: '热血战斗', icon: 'ri-fire-line', count: 980, color: 'primary' },
  { id: 6, name: '奇幻冒险', icon: 'ri-magic-line', count: 1120, color: 'secondary' },
  { id: 7, name: '悬疑推理', icon: 'ri-search-eye-line', count: 650, color: 'accent' },
  { id: 8, name: '搞笑日常', icon: 'ri-emotion-laugh-line', count: 890, color: 'primary' },
  { id: 9, name: '已完结', icon: 'ri-check-double-line', count: 4500, color: 'secondary' },
];

export const topicsData = [
  { id: 1, name: '韩漫推荐', count: 12.8, unit: '万讨论' },
  { id: 2, name: '日漫新番', count: 9.6, unit: '万讨论' },
  { id: 3, name: '国漫崛起', count: 8.4, unit: '万讨论' },
  { id: 4, name: '漫画追更', count: 7.2, unit: '万讨论' },
  { id: 5, name: '恋爱漫画', count: 6.5, unit: '万讨论' },
  { id: 6, name: '热血番推荐', count: 5.9, unit: '万讨论' },
  { id: 7, name: '完结漫画', count: 5.1, unit: '万讨论' },
  { id: 8, name: '漫改动画', count: 4.8, unit: '万讨论' },
  { id: 9, name: '漫画安利', count: 4.3, unit: '万讨论' },
];

export const aboutData = {
  title: '关于YY漫画',
  content:
    'YY漫画网成立于2022年，是国内领先的免费漫画在线阅读平台。我们致力于为广大漫画爱好者提供最全、最新、最优质的韩漫、日漫、国漫资源。平台采用先进的下拉式阅读技术，让读者无需翻页即可流畅阅读每一话漫画。无论你是在通勤路上、午休时间还是睡前放松，YY漫画都能为你带来极致的阅读体验。',
  highlights: [
    { icon: 'ri-book-open-line', text: '50,000+部漫画，持续更新中' },
    { icon: 'ri-group-line', text: '300万+活跃读者社区' },
    { icon: 'ri-smartphone-line', text: '全平台适配，随时随地阅读' },
    { icon: 'ri-shield-check-line', text: '正版授权，绿色安全阅读' },
  ],
};

export const mediaData = [
  {
    id: 1,
    title: '《女神降临》最新话抢先看',
    desc: '女主角素颜大揭秘，男主角终于发现真相！这一话甜度爆表，不容错过。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20scene%20illustration%20with%20beautiful%20female%20protagonist%20and%20handsome%20male%20lead%20romantic%20moment%20warm%20lighting%20clean%20simple%20background%20soft%20colors%20artistic%20style&width=600&height=400&seq=media-01&orientation=landscape',
    tag: '韩漫热播',
    duration: '15分钟前',
  },
  {
    id: 2,
    title: '《咒术回战》五条悟名场面合集',
    desc: '盘点五条悟最燃战斗场景，每一个画面都让人热血沸腾。日漫迷必看！',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20action%20battle%20scene%20illustration%20with%20powerful%20sorcerer%20character%20dynamic%20pose%20dark%20dramatic%20lighting%20clean%20simple%20background%20intense%20atmosphere%20artistic%20style&width=600&height=400&seq=media-02&orientation=landscape',
    tag: '日漫精选',
    duration: '2小时前',
  },
  {
    id: 3,
    title: '《斗破苍穹》萧炎突破斗皇',
    desc: '国漫巅峰之战，萧炎突破斗皇境界，三上云岚宗复仇！特效炸裂，燃到飞起。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20epic%20fantasy%20battle%20scene%20illustration%20with%20warrior%20character%20surrounded%20by%20flames%20dramatic%20pose%20clean%20simple%20background%20warm%20orange%20tones%20artistic%20style&width=600&height=400&seq=media-03&orientation=landscape',
    tag: '国漫精选',
    duration: '6小时前',
  },
];

export const carouselData = [
  {
    id: 1,
    title: '韩漫专区 · 高质量恋爱漫推荐',
    desc: '精选20部画风精美、剧情在线的韩漫恋爱作品，每一部都值得反复阅读。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20featuring%20elegant%20couple%20characters%20in%20beautiful%20setting%20soft%20pastel%20color%20palette%20dreamy%20romantic%20atmosphere%20clean%20simple%20background%20artistic%20style%20warm%20lighting&width=1200&height=500&seq=carousel-01&orientation=landscape',
    tag: '韩漫',
    color: 'accent' as const,
  },
  {
    id: 2,
    title: '日漫热血番 · 燃到停不下来',
    desc: '从《咒术回战》到《鬼灭之刃》，精选最燃日漫热血作品合集。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20action%20illustration%20with%20dynamic%20battle%20characters%20intense%20fighting%20scene%20bold%20colors%20dramatic%20composition%20clean%20simple%20background%20artistic%20style&width=1200&height=500&seq=carousel-02&orientation=landscape',
    tag: '日漫',
    color: 'primary' as const,
  },
  {
    id: 3,
    title: '国漫崛起 · 玄幻巨作不容错过',
    desc: '国漫玄幻题材天花板，《斗破苍穹》《完美世界》领衔年度必看榜。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20epic%20fantasy%20illustration%20with%20magnificent%20ancient%20Chinese%20palace%20and%20flying%20warriors%20golden%20and%20red%20tones%20majestic%20atmosphere%20clean%20simple%20background%20artistic%20style&width=1200&height=500&seq=carousel-03&orientation=landscape',
    tag: '国漫',
    color: 'secondary' as const,
  },
  {
    id: 4,
    title: '新番速递 · 本周必追连载推荐',
    desc: '本周更新的热门漫画一网打尽，追更党福音，不错过任何精彩章节。',
    image: 'https://readdy.ai/api/search-image?query=Comic%20book%20collection%20illustration%20with%20stacked%20colorful%20manga%20volumes%20and%20reading%20accessories%20warm%20cozy%20atmosphere%20clean%20simple%20background%20artistic%20style%20bright%20lighting&width=1200&height=500&seq=carousel-04&orientation=landscape',
    tag: '新番',
    color: 'accent' as const,
  },
  {
    id: 5,
    title: '完结神作 · 一口气看到大结局',
    desc: '已完结的高评分漫画合集，不用等更新，直接畅读全本。',
    image: 'https://readdy.ai/api/search-image?query=Completed%20manga%20collection%20illustration%20with%20finished%20book%20series%20lined%20up%20beautifully%20satisfying%20completion%20theme%20warm%20golden%20lighting%20clean%20simple%20background%20artistic%20style&width=1200&height=500&seq=carousel-05&orientation=landscape',
    tag: '完结',
    color: 'primary' as const,
  },
  {
    id: 6,
    title: '编辑力荐 · 冷门佳作发掘计划',
    desc: '那些被埋没的高质量漫画，编辑团队精心筛选，每一部都值得一看。',
    image: 'https://readdy.ai/api/search-image?query=Hidden%20gem%20comic%20books%20illustration%20with%20spotlight%20on%20unique%20artistic%20manga%20covers%20warm%20ambient%20lighting%20clean%20simple%20background%20artistic%20style%20discovery%20theme&width=1200&height=500&seq=carousel-06&orientation=landscape',
    tag: '推荐',
    color: 'secondary' as const,
  },
];

export const cardsData = [
  {
    id: 1,
    title: '《女神降临》第128话更新',
    desc: '素颜秘密被揭开后，修豪的反应让人出乎意料！甜度再创新高。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20beautiful%20female%20character%20with%20makeup%20transformation%20theme%20soft%20warm%20lighting%20clean%20simple%20background%20artistic%20style&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '韩漫 · 恋爱',
    badge: 'HOT',
  },
  {
    id: 2,
    title: '《咒术回战》涉谷事变篇',
    desc: '五条悟被封印，咒术界迎来史上最大危机。剧情进入白热化阶段！',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20dark%20urban%20battle%20illustration%20with%20sorcerer%20characters%20fighting%20in%20city%20setting%20dramatic%20lighting%20clean%20simple%20background%20artistic%20style&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '日漫 · 热血',
    badge: 'NEW',
  },
  {
    id: 3,
    title: '《斗破苍穹》三上云岚宗',
    desc: '萧炎携异火强势回归，云岚宗大战一触即发。国漫巅峰对决！',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20epic%20battle%20illustration%20with%20flame%20warrior%20facing%20enemy%20army%20dramatic%20orange%20fire%20theme%20clean%20simple%20background%20artistic%20style&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '国漫 · 玄幻',
    badge: '热',
  },
  {
    id: 4,
    title: '《我独自升级》S级猎人篇',
    desc: '成振宇觉醒隐藏能力，从最弱猎人逆袭为最强S级。韩漫天花板！',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20dungeon%20hunter%20illustration%20with%20cool%20black%20armored%20character%20shadow%20theme%20dark%20atmosphere%20clean%20simple%20background%20artistic%20style&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '韩漫 · 动作',
    badge: 'HOT',
  },
  {
    id: 5,
    title: '《间谍过家家》欢乐家庭篇',
    desc: '黄昏、约尔和阿尼亚的温馨又搞笑的家庭日常，笑到停不下来！',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20comedy%20family%20illustration%20with%20eccentric%20family%20characters%20warm%20home%20setting%20bright%20cheerful%20colors%20clean%20simple%20background%20artistic%20style&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '日漫 · 搞笑',
    badge: '荐',
  },
  {
    id: 6,
    title: '《某天成为公主》王室篇',
    desc: '穿越成为公主后，如何在王室阴谋中生存？画风绝美的奇幻佳作。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20princess%20illustration%20with%20elegant%20royal%20palace%20setting%20beautiful%20dress%20soft%20pink%20tones%20clean%20simple%20background%20artistic%20style&width=600&height=400&seq=card-06&orientation=landscape',
    tag: '韩漫 · 奇幻',
    badge: 'NEW',
  },
  {
    id: 7,
    title: '《完美世界》石昊逆天改命',
    desc: '少年石昊从大荒走出，征战九天十地。国漫玄幻史诗级巨作！',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20martial%20arts%20illustration%20with%20young%20warrior%20in%20ancient%20Chinese%20setting%20golden%20light%20theme%20clean%20simple%20background%20artistic%20style&width=600&height=400&seq=card-07&orientation=landscape',
    tag: '国漫 · 玄幻',
    badge: '热',
  },
];

export const updatesData = [
  { id: 1, title: '《女神降临》第128话', time: '刚刚更新', type: '韩漫' },
  { id: 2, title: '《咒术回战》第243话', time: '15分钟前', type: '日漫' },
  { id: 3, title: '《斗破苍穹》第568话', time: '30分钟前', type: '国漫' },
  { id: 4, title: '《我独自升级》第179话', time: '1小时前', type: '韩漫' },
  { id: 5, title: '《间谍过家家》第87话', time: '2小时前', type: '日漫' },
  { id: 6, title: '《完美世界》第312话', time: '3小时前', type: '国漫' },
  { id: 7, title: '《某天成为公主》第142话', time: '4小时前', type: '韩漫' },
  { id: 8, title: '《鬼灭之刃》番外篇', time: '5小时前', type: '日漫' },
  { id: 9, title: '《星辰变》第456话', time: '6小时前', type: '国漫' },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-file-list-2-line',
    title: '下拉式阅读',
    desc: '独创下拉式阅读模式，无需翻页即可流畅浏览漫画全话内容，沉浸在阅读世界中。',
  },
  {
    id: 2,
    icon: 'ri-bookmark-line',
    title: '追更收藏',
    desc: '一键收藏喜爱漫画，更新实时通知。不错过任何一话，追更路上快人一步。',
  },
  {
    id: 3,
    icon: 'ri-global-line',
    title: '海量资源',
    desc: '5万+漫画作品，涵盖韩漫、日漫、国漫三大品类，每周持续上新。',
  },
  {
    id: 4,
    icon: 'ri-device-line',
    title: '多端适配',
    desc: 'PC、平板、手机全平台适配，无论在哪里都能享受最佳阅读体验。',
  },
];

export const faqData = [
  {
    id: 1,
    q: 'YY漫画是免费的吗？',
    a: '是的，YY漫画网所有漫画资源均为免费阅读，无需付费订阅。我们致力于为漫画爱好者提供完全免费的在线阅读体验，所有漫画均可免费畅读。',
  },
  {
    id: 2,
    q: '下拉式阅读是什么意思？',
    a: '下拉式阅读是一种创新的漫画浏览方式，读者只需向下滚动页面即可连续阅读漫画内容，无需像传统翻页那样一页一页点击。这种方式更加流畅自然，让阅读体验更沉浸。',
  },
  {
    id: 3,
    q: '如何收藏漫画并追更？',
    a: '在漫画详情页点击收藏按钮即可将漫画加入你的书架。收藏后，当该漫画有更新时，系统会在首页为你推送更新提醒，让你第一时间追到最新话。',
  },
  {
    id: 4,
    q: '支持哪些类型的漫画？',
    a: 'YY漫画网涵盖韩漫、日漫、国漫三大品类，包括恋爱、热血、奇幻、悬疑、搞笑、玄幻等多种题材。无论你喜欢什么类型，都能在这里找到心仪的作品。',
  },
  {
    id: 5,
    q: '可以在手机上阅读吗？',
    a: '当然可以！YY漫画网完美适配手机、平板和电脑端。在手机上同样支持下拉式阅读，随时随地都能享受流畅的漫画阅读体验。此外还提供APP下载，体验更佳。',
  },
  {
    id: 6,
    q: '漫画资源更新频率如何？',
    a: '我们每日更新超过200部漫画，热门连载作品保持与官方同步更新。所有资源均由编辑团队精心维护，确保漫画质量和阅读体验。',
  },
];

export const contactData = {
  title: '投稿联系',
  intro:
    '如果你有优秀的原创漫画作品，或者想要向我们推荐好看的漫画资源，欢迎通过以下方式联系我们。YY漫画致力于发现和推广优质漫画内容，期待与你的合作！',
  items: [
    { icon: 'ri-mail-line', label: '投稿邮箱', value: 'submission@yymanhua.com' },
    { icon: 'ri-wechat-line', label: '官方微信', value: 'YY漫画官方' },
    { icon: 'ri-link', label: '合作联系', value: 'cooperation@yymanhua.com' },
  ],
};

export const appData = {
  title: '随时随地畅享漫画',
  desc: '下载YY漫画APP，享受更流畅的下拉式阅读体验。支持离线下载、夜间模式、自动追更提醒等专属功能。',
  features: ['下拉式阅读', '离线下载', '追更提醒', '夜间模式', '书签同步', '社区互动'],
  image: 'https://readdy.ai/api/search-image?query=Mobile%20app%20mockup%20for%20comic%20reading%20application%20showing%20manga%20reader%20interface%20on%20smartphone%20screen%20with%20colorful%20comic%20pages%20clean%20modern%20UI%20design%20warm%20lighting%20artistic%20style&width=400&height=800&seq=app-mockup-01&orientation=portrait',
};